import MemLearning from '@memrise/memlearning';
import { SessionType, TestSettings } from 'src/api/learningSessions/types';

export const makeTestSettings = (testSettings: TestSettings, sessionType: SessionType) => {

    const isTappingDisabled = testSettings.disableTapping;
    const isTypingDisabled = testSettings.disableTyping;
    let isMultimediaDisabled = false;

    // Disabling Multimedia within these sessions will break them
    if (sessionType !== SessionType.AUDIO && sessionType !== SessionType.VIDEO) {
        isMultimediaDisabled = testSettings.disableMultimedia;
    }

    return new MemLearning.com.memrise.learning.tests.TestSettings(
        isMultimediaDisabled,
        isTappingDisabled,
        isTypingDisabled,
    );
}
